import {
  Group,
  Identifiable,
  OrganizationalUnit,
  Project,
  ProjectPortfolio,
  ProjectStatus,
  Resource,
  Role,
  Tag,
  Zone,
} from "@planzone/dto";

// A unit picked in the filter, or unchecked under a picked one: each unit takes the state of its closest
// entry, itself or an ancestor. Entries saved before the exclusions have no flag and are picked units.
type OrganizationalUnitFilterEntry = Identifiable<OrganizationalUnit> & {
  isExcluded?: boolean;
};

type ResourceStatus = "activated" | "deactivated";

type Filter = {
  zones?: Identifiable<Zone>[];
  projects?: Identifiable<Project>[];
  projectsElementsTags?: Tag[];
  projectsTags?: Tag[];
  resources?: Identifiable<Resource>[];
  resourceTags?: Tag[];
  groups?: Identifiable<Group>[];
  projectPortfolios?: Identifiable<ProjectPortfolio>[];
  projectStatuses?: Identifiable<ProjectStatus>[];
  roles?: Identifiable<Role>[];
  organizationalUnits?: OrganizationalUnitFilterEntry[];
  // None or both mean every resource.
  resourceStatuses?: ResourceStatus[];
};

const filter: Filter = {};

export type { Filter, OrganizationalUnitFilterEntry, ResourceStatus };

export { filter };
